export default __webpack_public_path__ + "static/outer_bottom-0164ac7257918d1d4f32bd9580376bbe.png";